import { ErrorPageTheme } from '@/components/ErrorPage/theme';
import { GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: ErrorPageTheme });

const Base = $({ as: 'div', slot: 'base' });
const Headline = $({ as: 'h1', slot: 'headline' });
const Description = $({ as: 'div', slot: 'description' });

export const ErrorPage = Object.assign(Base, {
  Headline,
  Description,
});
